import {
  A
} from "./chunk.BPIW577J.js";

// node_modules/.pnpm/lit-html@3.3.3/node_modules/lit-html/directives/if-defined.js
var o = (o2) => o2 ?? A;

export {
  o
};
/*! Bundled license information:

lit-html/directives/if-defined.js:
  (**
   * @license
   * Copyright 2018 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)
*/
